import React from 'react';
import Switch from 'components/Common/Switch';
import {
  Table, TableBody, TableCell, TableHead, TableRow,
} from '@mui/material';
import { styled } from '@mui/material/styles';


const StyledCell = styled(TableCell)(() => (
  {
    'font-weight': 'bold',
  }
));

const CleanRoomTypesTable = ({ list, cleanRoomTypes, setCleanRoomType }) => {
  const onToggle = (cleanRoomType, isChecked) => {
    if (!isChecked) {
      setCleanRoomType(cleanRoomTypes.filter(i => i !== cleanRoomType.ID));
    }
    else {
      setCleanRoomType([...cleanRoomTypes, cleanRoomType.ID]);
    }
  };

  // Filter out the Hybrid clean room type for now
  const filteredList = list
    .filter(row => row.displayName !== 'Hybrid') // Keep only 'HybridV2'
    .map(row => ({
      ...row,
      displayName: row.displayName === 'HybridV2' ? 'Hybrid' : row.displayName, // Rename 'HybridV2' to 'Hybrid'
    }));

  return (
    <Table size='small'>
      <TableHead>
        <TableRow>
          <TableCell width='5%' />
          <StyledCell>
            Clean Room Types
          </StyledCell>
        </TableRow>
      </TableHead>
      <TableBody>
        {filteredList.map(row => (
          <TableRow key={row.ID}>
            <TableCell>
              <Switch
                checked={cleanRoomTypes?.indexOf(row.ID) !== -1}
                value={row.ID}
                onChange={e => onToggle(row, e.target.checked)}
              />
            </TableCell>
            <TableCell>
              {row.displayName}
            </TableCell>
          </TableRow>
        ))}
      </TableBody>
    </Table>
  );
};

export default CleanRoomTypesTable;
